import { Box, Button, Card, CardMedia, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { CustomTheme, Theme } from "helpers/Theme";
import { ArrowNextCircle } from "icons";

const getStyles = makeStyles((theme: CustomTheme) => ({
  card: (height: HeightProps) => ({
    height: height.value,
    position: "relative",
    cursor: "pointer",
    borderRadius: 10
  }),
  title: () => ({
    position: "absolute",
    bottom: "5%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    textAlign: "center",
    color: theme.palette.common.white,
    fontSize: 26,
    borderBottom: `solid 2px ${theme.palette.primary.main}`,
    transition: "opacity 0.45s ease",
    paddingBlock: 10
  }),
  cardDetailt: (height: HeightProps) => ({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "absolute",
    bottom: "100%",
    left: "0",
    width: "100%",
    height: `${height.value}px`,
    backgroundColor: "#11151A",
    transition: "bottom 0.45s ease, transform 0.45s ease",
    transform: "translateY(0%)",
    borderRadius: 10
  }),
  cardDetailtBody: {
    width: "90%",
    height: "93%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-between"
  },
  cardHover: (height: HeightProps) => ({
    "&:hover $cardDetailt": {
      bottom: `calc(100% - ${height.value}px)`,
      animation: "bounce 0.65s ease"
    },
    "&:hover $title": {
      opacity: 0
    }
  })
}));

type HeightProps = {
  value: number;
};
type AnimateTourCardProps = {
  isExtended: boolean;
  cardOfert?: boolean;
  image?: string;
  title?: string;
  name?: string;
  description?: string;
  price?: string;
  width?: number;
};
export const AnimateTourCard = ({
  isExtended = false,
  cardOfert = false,
  width = 350,
  image,
  title,
  name,
  description,
  price
}: AnimateTourCardProps) => {
  const height: HeightProps = {
    value: cardOfert ? 382 : isExtended ? 571 : 411
  };

  const styles = getStyles(height);
  return (
    <Card elevation={0} sx={{ width: width }} className={`${styles.card} ${styles.cardHover}`}>
      <Typography className={styles.title}>{title}</Typography>
      <CardMedia
        sx={{ borderRadius: 3 }}
        component="img"
        alt={title}
        aria-label={title}
        height="100%"
        image={image}
        loading="lazy"
      />
      <Box className={styles.cardDetailt}>
        <Box className={styles.cardDetailtBody}>
          <Box width="100%" display="flex" justifyContent="space-between" alignItems="center">
            <Typography fontSize={26} color={Theme.palette.common.white}>
              {name}
            </Typography>
            <picture>
              <img
                src={image}
                alt={title}
                aria-label={title}
                style={{ objectFit: "cover", borderRadius: 7 }}
                width={72}
                height={107}
                loading="lazy"
              />
            </picture>
          </Box>
          <Typography
            fontSize={15}
            color={Theme.palette.common.white}
            sx={{ overflow: "auto", textOverflow: "ellipsis" }}>
            {description}
          </Typography>
          <Box width="100%" display="flex" gap={3} alignItems="center">
            <Button variant="contained" sx={{ flex: 1, borderRadius: 100 }}>
              {price}
            </Button>
            <Button sx={{ minWidth: 0 }}>
              <ArrowNextCircle />
            </Button>
          </Box>
        </Box>
      </Box>
    </Card>
  );
};
